export default __webpack_public_path__ + "static/media/profile-menu-icon-white.e2ef5a20.svg";